<template>

    <div class="vehicle-type-filter"
         v-on:keypress.enter.prevent
    >
        <div class="container">

            <div class="row">

                <template v-if="hideLocationSelector">

                    <input v-for="(location, i) in selectedValues.locations" type="hidden"
                           name="location_slugs[]"
                           :value="location.slug">
                </template>

                <div
                        v-if="!hideLocationSelector"
                        class="d-flex flex-column justify-content-start align-items-center mb-3 mb-md-0 select-locations"
                        v-bind:class="columnSectionClassesLocation"
                >


                    <div class="d-flex flex-row justify-content-start align-items-center w-100">
                        <label class="single-location" v-if="!searchBySingleLocation">
                            <i class="fas fa-map-marker fa-xs label-icon"></i>Pickup Location(s)
                        </label>

                      <label class="single-location" v-if="searchBySingleLocation">
                        <i class="fas fa-map-marker fa-xs label-icon"></i>Pickup Location
                      </label>

                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12 mb-2" v-bind:class="{'p-0': useColumns}">
                                    <auto-suggest-input
                                            ref="location-search"
                                            name="location_slugs"
                                            v-model="selectedValues.locations"
                                            :required="true"
                                            :multiple="!searchBySingleLocation"
                                            :max-selectable="searchBySingleLocation ? 1 : 3"
                                            search-uri="/api/local/search-locations"
                                            placeholder="Enter postcode or suburb"
                                            @input="$_dispatchLocationChange"
                                    ></auto-suggest-input>

                                </div>
                            </div>
                            <div class="row d-none d-md-flex">
                                <div class="col-9">

                                    <div class="inputGroup inputGroup--checkbox">
                                        <input type="checkbox" id="same_location_toggle" name="same_location_toggle"
                                               value="Return to the same Hertz location" class="requires-js-interactive"
                                               :checked="returnToSameLocation"
                                               v-on:click="$_showLocationWarning"
                                        >
                                        <label for="same_location_toggle" id="same_location_toggle_label"
                                               class="requires-js-interactive">Return to the same Hertz location</label>
                                    </div>

                                    <div class="inputGroup inputGroup--checkbox">
                                        <input type="checkbox"
                                               id="codes_toggle"
                                               name="codes_toggle"
                                               value="true"
                                               class="requires-js-interactive"
                                               v-model="couponsVisible"
                                        >
                                        <label for="codes_toggle" class="requires-js-interactive">Enter a Discount or
                                            Promo
                                            Code</label>
                                    </div>
                                </div>
                                <div class="col-3 p-0">
                                    <button type="button"
                                            v-if="mapElement"
                                            v-on:click="dispatchToggleMap()"
                                            class="mapButton requires-js-interactive d-flex ml-auto justify-content-center"
                                    >

                                        <i class="fas fa-map mapButton__icon"></i>

                                        <template v-if="!mapToggled">
                                            <span class="mapButton__mapText">Map</span>
                                        </template>
                                        <template v-else>
                                <span class="mapButton__closeText">
                                    <i class="mapButton__closeIcon fas fa-times op-70"></i>
                                    Close
                                </span>
                                        </template>

                                    </button>
                                </div>
                            </div>


                        </div>


                    </div>

                </div>

                <div
                        class="align-items-end align-items-md-center d-flex flex-md-column flex-row justify-content-start mb-3 mb-md-0 select-time pr-sm-2 pr-md-3 pr-2 pl-2"
                        v-bind:class="columnSectionClassesDates"
                >
                    <div class="inputGroup"
                         v-bind:class="{
                            'mr-2 mr-md-0': columnCount !== 1,
                            'w-100': columnCount !== 1
                        }"

                    >

                        <div class="container-fluid p-0 time-controls">
                            <div class="row">
                                <div class="col-12 pr-0 pl-2 pl-md-3">
                                    <label class="d-inline-block"
                                           v-bind:class="{ }"
                                    ><i class="fas fa-calendar-alt fa-xs label-icon"></i>From</label>

                                    <div class="container-fluid p-0" v-bind:class="{'offset-patch pl-2 pl-md-0':
                                    !useColumns}">
                                        <div class="row">
                                            <div class="col-7 pr-1" v-bind:class="{'pl-1': !useColumns}">
                                                <flat-pickr
                                                        v-model="selectedValues.fromDate"
                                                        placeholder="Pickup Date"
                                                        :config="dateConfig.fromDate"
                                                        name="fromDate"
                                                        class="filter-time"
                                                        v-bind:class="{
                                    'w-100': true
                                }"
                                                        autocomplete="false"
                                                        @on-change="(e) => { $_fromDateChange(e); $_updateTimeValues('change');}"
                                                        @on-open="$_updateTimeValues('open')"
                                                        @on-close="$_updateTimeValues('close')"
                                                        @on-input="$_updateTimeValues('input')"
                                                ></flat-pickr>
                                            </div>
                                            <div class="col-5 pl-1">
                                                <flat-pickr
                                                        v-model="selectedValues.fromTime"
                                                        placeholder="Pickup Time"
                                                        :config="dateConfig.fromTime"
                                                        name="fromTime"
                                                        class="filter-time"
                                                        v-bind:class="{
                                    'w-100': true
                                }"
                                                        @on-change="(e) => {$_fromTimeChange(e); $_updateTimeValues('change');}"
                                                        @on-open="$_updateTimeValues('open')"
                                                        @on-close="$_updateTimeValues('close')"
                                                        @on-input="$_updateTimeValues('input')"
                                                        autocomplete="false"
                                                ></flat-pickr>
                                            </div>
                                        </div>
                                    </div>



                                    <input name="from" v-model="selectedValues.from" class="time-to-post">
                                </div>
                                <div class="col-12 pl-2 pr-0 pl-md-3">
                                    <label class="d-inline-block"
                                           v-bind:class="{ }"
                                    ><i class="fas fa-calendar-alt fa-xs label-icon"></i>To</label>

                                    <div class="container-fluid p-0" v-bind:class="{'offset-patch pl-2 pl-md-0':
                                    !useColumns}">
                                        <div class="row">
                                            <div class="col-7 pr-1" v-bind:class="{'pl-1': !useColumns}">
                                                <flat-pickr
                                                        v-model="selectedValues.toDate"
                                                        placeholder="Return Date"
                                                        :config="dateConfig.toDate"
                                                        name="toDate"
                                                        class="filter-time"
                                                        v-bind:class="{
                                    'w-100': true
                                }"
                                                        autocomplete="false"
                                                        @on-change="(e) => { $_toDateChange(e); $_updateTimeValues('change');}"
                                                        @on-open="$_updateTimeValues('open')"
                                                        @on-close="$_updateTimeValues('close')"
                                                        @on-input="$_updateTimeValues('input')"
                                                ></flat-pickr>
                                            </div>
                                            <div class="col-5 pl-1">
                                                <flat-pickr
                                                        v-model="selectedValues.toTime"
                                                        placeholder="Return Time"
                                                        :config="dateConfig.toTime"
                                                        name="toTime"
                                                        class="filter-time"
                                                        v-bind:class="{
                                    'w-100': true
                                }"
                                                        autocomplete="false"
                                                        @on-change="(e) => {$_toTimeChange(e); $_updateTimeValues('change');}"
                                                        @on-open="$_updateTimeValues('open')"
                                                        @on-close="$_updateTimeValues('close')"
                                                        @on-input="$_updateTimeValues('input')"
                                                ></flat-pickr>
                                            </div>
                                        </div>
                                    </div>



                                    <input name="to" v-model="selectedValues.to" class="time-to-post">
                                </div>

                                <div class="col-sm-4 d-md-none col-xs-12 pr-0">
                                    <label class="d-inline-block"></label>
                                    <button type="button"
                                            v-if="mapElement"
                                            v-on:click="dispatchToggleMap()"
                                            class="mapButton requires-js-interactive d-flex ml-auto justify-content-center"
                                    >

                                        <i class="fas fa-map mapButton__icon"></i>

                                        <template v-if="!mapToggled">
                                            <span class="mapButton__mapText">Map</span>
                                        </template>
                                        <template v-else>
                                <span class="mapButton__closeText">
                                    <i class="mapButton__closeIcon fas fa-times op-70"></i>
                                    Close
                                </span>
                                        </template>

                                    </button>
                                </div>
                            </div>
                        </div>


                        <br v-if="columnCount !== 1">


                    </div>

                </div>

                <throbber-overlay v-if="loadingSomething"></throbber-overlay>

                <div class="d-flex justify-content-center align-items-center select-vehicle-types"
                     v-if="!hideVehicleTypeSelector"
                     v-bind:class="columnSectionClassesVehicle"
                >


                    <div id="vehicle_type_group" class="inputGroup mb-md-2 mb-3 w-100">
                        <div class="vehicle-type">
                            <label><i class="fas fa-truck fa-xs label-icon"></i>Vehicle Type(s)</label>

                            <multiselect class="locationInputs__locationInput filter-locations w-100"
                                         v-model="selectedValues.vehicles"
                                         :options="selectableVehicleTypes"
                                         :multiple="true"
                                         :max="3"
                                         :allow-empty="true"
                                         :hide-selected="true"
                                         placeholder="Vehicle Type"
                                         track-by="name"
                                         label="name"
                                         @input="$_dispatchVehicleChange"
                            ></multiselect>

                            <input v-for="(vehicleType, i) in selectedValues.vehicles" type="hidden"
                                   name="vehicle_type[]"
                                   :value="vehicleType.slug">

                            <label class="text-danger results-message"
                                   v-if="currentError">
                                {{currentError}}
                            </label>
                            <label
                                    v-if="!currentError"
                                    v-bind:class="{
                                        'results-message': useColumns
                                    }"
                            >
                                {{selectableVehicleTypes.length}} vehicle type<template v-if="selectableVehicleTypes.length != 1">s</template>
                                available
                            </label>
                        </div>


                        <template v-if="!hidePriceRange">
                            <div class="price-range">
                                <label>Min/day - ${{$_formatPrice(selectedValues.priceRange.min)}}</label>
                                <input type="range"
                                       v-model.number="selectedValues.priceRange.min"
                                       min="0"
                                       max="500"
                                       disabled-v-bind:max="Math.min(selectedValues.priceRange.max - 1, 299)"
                                       @change="$_dispatchPriceChange"
                                >
                                <label>Max/day - ${{$_formatPrice(selectedValues.priceRange.max)}}</label>
                                <input type="range"
                                       v-model.number="selectedValues.priceRange.max"
                                       disabled-v-bind:min="Math.max(selectedValues.priceRange.min + 1, 1)"
                                       min="0"
                                       max="500"
                                       @change="$_dispatchPriceChange"
                                >
                            </div>
                        </template>


                        <template v-if="selectablePurposes.length > 0">
                            <div class="purposes">
                                <multiselect class="locationInputs__purposeInput filter-purposes w-100"
                                             v-model="selectedValues.purposes"
                                             :options="selectablePurposes"
                                             :multiple="true"
                                             :allow-empty="true"
                                             :hide-selected="true"
                                             placeholder="Vehicle Purpose"
                                             track-by="value"
                                             label="label"
                                             @input="$_dispatchPurposeChange"
                                ></multiselect>
                            </div>
                        </template>

                    </div>

                </div>

            </div>
        </div>


        <div class="container" v-if="!hideToggles">

            <div class="row d-flex d-md-none">
                <div class="col-12">

                    <div class="inputGroup inputGroup--checkbox">
                        <input type="checkbox" id="same_location_toggle" name="same_location_toggle"
                               value="Return to the same Hertz location" class="requires-js-interactive"
                               :checked="returnToSameLocation"
                               v-on:click="$_showLocationWarning"
                        >
                        <label for="same_location_toggle" id="same_location_toggle_label"
                               class="requires-js-interactive">Return to the same Hertz location</label>
                    </div>

                    <div class="inputGroup inputGroup--checkbox">
                        <input type="checkbox"
                               id="codes_toggle"
                               name="codes_toggle"
                               value="true"
                               class="requires-js-interactive"
                               v-model="couponsVisible"
                        >
                        <label for="codes_toggle" class="requires-js-interactive">Enter a Discount or
                            Promo
                            Code</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <!--<div class="col-md-6">
                </div>-->

                <div class="col-md-2 d-flex justify-content-center justify-content-md-end ml-auto pr-0 mt-3 mt-md-0"
                     v-if="!noButton">
                    <button class="button bookingForm__submit requires-js-interactive"
                            v-bind:disabled="!canSubmit"
                            @click="$_searchFromClick"
                    >
                        <span class="action-text">Search</span>
                    </button>
                </div>
            </div>
        </div>

        <div id="promo_code_inputs" class="container" v-if="couponsVisible">
            <div class="row">
                <div class="align-items-center col-12 d-flex justify-content-between justify-content-sm-start mb-2">
                    <h4 class="promoFields__title d-inline-block m-0">Discount & Promo Codes</h4>
                    <button type="button" title="Discount & Promo Codes Info"
                            @click="$_showCouponHelp()"
                            class="promoFields__infoButton ml-sm-2 d-inline-block">
                        <i class="fas fa-question promoFields__infoButtonIcon"></i>
                    </button>

                    <div class="coupon-help-text">
                        <h5>Discount/CDP/Club Code:</h5>
                        <p>A counter discount program, or "CDP", is a contract or program that has been established in
                            cooperation with a company or organization under which individuals with specified
                            characteristics are entitled to rent on rental terms that differ from those generally
                            offered to the public. Examples of CDP’s include corporate rate plans and credit card and
                            travel club discount programs. CDP’s are identified by using unique numbers ("CDP Numbers"),
                            and require those who wish to rent under the terms of a CDP to furnish Hertz with the
                            appropriate CDP Number. A CDP Number consists of numerical values and is between 1 and 10
                            digits long. This number can also be used in conjunction with a PC (Promotion Code), RQ
                            (Rate Code) or CV (Convention Number) if the special offer or promotion requires additional
                            information is included in the reservation. Identification to verify eligibility of CDP
                            discount must be presented by Gold and Platinum Members at the first time of rental using a
                            particular CDP discount, and by all other renters at every time of rental to receive CDP
                            benefits.</p>

                        <h5>Promotion Coupon (PC):</h5>
                        <p>A six-digit number that is associated with a special offer or promotion. This number can also
                            be used in conjunction with a CDP (Discount Program) or RQ (Rate Code) if the special offer
                            or promotion requires additional information be included in the reservation.</p>

                        <h5>Rate Code (RQ)
                        </h5>
                        <p>A four to six digit code that is used to trigger discounts off of standard leisure rates.
                            This number is often displayed in a special offer with the text “I was told to ask for”. An
                            RQ can also be used in conjunction with a CDP (Discount Program) or PC (Promotion Code) if
                            the special offer or promotion requires additional information be included in the
                            reservation.</p>

                        <h5>Convention (CV) Number
                        </h5>
                        <p>Unique meeting number for a group that will generate pre-negotiated, discounted meeting rates
                            and benefits. This should be inserted in the CV field when making a reservation to receive
                            pre-negotiated meeting rates. A CV number can only be used in conjunction with a CDP
                            (Discount Program) or RQ (Rate Code) if the negotiated meeting rate allows additional
                            information be included in the reservation.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="align-items-end col-12 d-flex flex-wrap justify-content-between justify-content-lg-between justify-content-md-between promoFields">
                    <div v-bind:class="{'inputGroup': !noCouponColumns}">
                        <label for="CDP_code">Discount/CDP/Club Code:</label>
                        <input
                                v-model="selectedValues.cdpCode"
                                type="text"
                                name="cdp_code"
                                id="CDP_code"
                                autocomplete="off"
                                @change="$_dispatchCouponChange"
                        >
                    </div>
                    <div v-bind:class="{'inputGroup': !noCouponColumns}">
                        <label for="promo_coupon">Promotional Coupon (PC):</label>
                        <input
                                v-model="selectedValues.promoCoupon"
                                type="text"
                                name="promo_coupon"
                                id="promo_coupon"
                                autocomplete="off"
                                @change="$_dispatchCouponChange"
                        >
                    </div>
                    <div v-bind:class="{'inputGroup': !noCouponColumns}">
                        <label for="rate_code">Rate Code (RQ):</label>
                        <input
                                v-model="selectedValues.rateCode"
                                type="text" name="rate_code"
                                id="rate_code"
                                autocomplete="off"
                                @change="$_dispatchCouponChange"
                        >
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>

<style lang="scss" scoped>
    .vehicle-type-filter {
        position: relative;

        ::v-deep > .container {

            .time-to-post {
                position: absolute;
                left: -1000px;
                top: -1000px;
                height: 0;
                width: 0;
                appearance: none;

                opacity: 0;
            }

            .offset-patch {
                margin-left: 2px;
            }

            @media (min-width: 768px) {
                .results-message {
                    position: absolute;
                }
            }

            input[type=range] {
                width: 100%;
            }

            .coupon-help-text {
                display: none;
            }

            label {
                margin-bottom: 0;
            }

            .select-locations {

                > div {
                    flex-direction: row !important;
                    flex-wrap: wrap;

                    > * {
                        display: block;
                    }

                    > label {
                        width: 100%;
                    }

                    > .select2-container {
                        flex-grow: 1;
                        margin-right: 5px;
                    }
                }

                //.single-location {
                //    margin-left: -15px;
                //    #booking-app & {
                //        margin-left: auto;
                //    }
                //}
            }

            .filter-time {
                font-size: 0.85rem;

                & + .filter-time {
                    margin-top: 5px;
                }
            }

            .time-controls {
                label {

                    #booking-app & {
                        margin-left: -10px;


                        @media (max-width: 769px) {
                            margin-left: auto;
                        }

                    }
                }
            }

            .multiselect {
                position: relative;
                height: auto !important;
                line-height: 1.2;
                margin-top: 2px;

                .multiselect__input {
                    border: 0;
                    margin: 0;
                    padding: 0;
                    background: none;
                    box-shadow: none;
                }

                .multiselect__content-wrapper {
                    position: absolute;
                    z-index: 1;
                    top: 100%;
                    left: 0;
                    right: 0;
                    max-height: 500px;
                    background: white;
                    border: 1px solid #aaa;
                    border-top: 0;
                    overflow: auto;

                    .multiselect__content {
                        display: block !important;
                    }

                    ul, li {
                        list-style: none;
                        margin: 0;
                        padding: 0;
                    }

                    li {
                        span.multiselect__option {
                            display: block;
                            padding: 6px 6px 6px 0.75em;
                            cursor: pointer;

                            &--disabled {
                                font-weight: bold;
                                padding-left: 6px;
                            }

                            &--selected, &--highlight {
                                background: #5897fb;
                                color: white;
                            }
                        }
                    }
                }

                .multiselect__input {
                    font-size: 0.85em;
                }

                .multiselect__single {
                    color: #9F9F9F;
                    font-size: 13.6px; //0.85em;
                }

                .multiselect__tags-wrap {
                    margin-top: -2px;
                }

                .multiselect__tags {
                    .multiselect__tag {
                        cursor: pointer;
                        display: inline-block;
                        font-size: 0.85rem;
                        background-color: #e6e6e6;
                        border: 1px solid #9f9f9f;
                        border-radius: 4px;
                        padding: 0 5px;
                        margin-right: 5px;
                        line-height: 1.5;

                        &-icon {
                            float: left;
                            font-style: normal;
                            margin-right: 5px;
                            opacity: 0.6;

                            &::after {
                                content: '×';
                            }
                        }

                    }
                }
            }

            .vehicle-type + .price-range {
                margin-top: 1em;
            }

            .location-search {
                > .input-wrap {
                    width: 100%;

                    button.query-location {
                        max-width: 4em;
                    }
                }
            }
        }
    }
</style>

<script>

    //@todo Add support to only perform requests for vehicle changes on search results pages

    import AutoSuggestInput from "./AutoSuggestInput";
    const Api = require('../../../../global/js/modules/api');
    const ThrobberOverlay = require('./ThrobberOverlay').default;
    const Multiselect = require('vue-multiselect').default;
    const VueUtils = require('../../modules/vue-utils');
    const flatPickr = require('vue-flatpickr-component');
    import 'flatpickr/dist/flatpickr.css';

    const now = new Date;
    let defaultHour = now.getHours() + 2;
    let defaultMinute;
    if (now.getMinutes() > 30) {
        defaultMinute = 0;
        defaultHour++;
    }
    else {
        defaultMinute = 30;
    }

    //@todo Refactor this out to a const module for inclusion and reference elsewhere
    const events = {
        initialized: 'vehicle-type-filter:initialized',
        mapToggled: 'vehicle-type-filter:map-visibility-toggled',
        selectableLocationsSet: 'vehicle-type-filter:selectable-locations-set',
        selectedLocation: 'vehicle-type-filter:selected-location',
        startedLoadingSomething: 'vehicle-type-filter:started-loading-something',
        stoppedLoadingSomething: 'vehicle-type-filter:stopped-loading-something',
        selectedVehicleTypes: 'vehicle-type-filter:selected-vehicle-type',
        startSearch: 'vehicle-type-filter:search-started',
        searchCompleted: 'vehicle-type-filter:search-completed',
        updatedPriceRange: 'vehicle-type-filter:updated-price-range',
        updatedVehiclePurpose: 'vehicle-type-filter:updated-purpose',
        updatedVehicleCoupons: 'vehicle-type-filter:updated-coupons',
    };

    function _startLoadingSomething(context) {
        if (context.loadingStack$ === 0) {
            _dispatchDomEvent(context.$el, events.startedLoadingSomething);
        }
        context.loadingStack$++;
    }

    function _stopLoadingSomething(context) {
        context.loadingStack$--;

        if (context.loadingStack$ === 0) {
            _dispatchDomEvent(context.$el, events.stoppedLoadingSomething);
        }
    }

    function _getMapElement(selector) {
        return document.querySelector(selector);
    }

    function _dispatchDomEvent($el, eventName, data = null) {
        let eventData = data === null
            ? {}
            : {detail: data};

        eventData.bubbles = true;

        let event;

        /*event = data === null
            ? new Event(eventName, eventData)
            : new CustomEvent(eventName, eventData);*/
        event = new CustomEvent(eventName, eventData);

        $el.dispatchEvent(event);
    }

    function _bind(context, selector, event, callback) {
        let $elements = context.$el.querySelectorAll(selector);
        for (let $element of $elements) {
            $element.addEventListener(event, callback);
        }
    }

    function _attemptSearch(location_slugs, vehicleTypes, from, to, discountCode, promotionalCode, rateCode,
                            voucherNumber) {

        return new Promise((resolve, reject) => {
            if (!location_slugs || !from || !to) {
                reject('Please ensure fields are correctly filled out');
            } else {
                let token = document.querySelector('[type="hidden"][name="_token"]');

                if (!token) {
                    reject('Could not find CSRF token field in current page');
                    return;
                }

                Api.remote.getVehiclesAndTypesForLocation({
                    location_slugs: location_slugs,
                    vehicle_types: vehicleTypes,
                    from, to,
                    _token: token.value,
                    discountCode,
                    promotionalCode,
                    rateCode,
                    voucherNumber
                })
                    .then(resolve, reject);
            }
        });
    }

    function _transformLocationModelsStructure(inLocations = []) {
        return inLocations;

        let out = [];

        for (let group of inLocations) {
            let groupOpt = {
                label: group.name,
                options: []
            };

            for (let location of group.locations) {
                groupOpt.options.push({
                    text: location.name,
                    value: location.slug
                })
            }

            out.push(groupOpt);
        }

        return out;
    }

    function _filterVehicles(context, incomingVehicles, incomingTypes, incomingPurposes) {
        let filteredVehicles = [];

        for (let i = 5; i >= 0; i--) {
            filteredVehicles.push([]);
        }

        let vehicles = incomingVehicles || context.lastCompleteSearchResponse;
        let types = incomingTypes || context.getSelectedTypes() || context.lastCompleteVehicleTypes || [];
        let purposes = incomingPurposes || context.getSelectedPurposes() || context.selectedValues.purposes;

        const typeAsArray = typeof types.length !== 'undefined';

        let typeSlugs = [];
        if (!typeAsArray) {
            typeSlugs = Object.keys(types);
        }

        if (vehicles) {
            for (let vehicle of vehicles) {
                let score = 5;

                //@todo determine what the purpose of this was, if anything... Why is it here?
                //if (typeAsArray && types.indexOf(vehicle.type.slug) < 0) {
                //

                //if the type list is not an array, someone has picked options. Compare the specified options
                //against the vehicle type/s
                if (!typeAsArray) {
                    let typePasses = false;
                    for (const type of vehicle.types) {
                        if (typeSlugs.indexOf(type.slug) >= 0) {
                            typePasses = true;
                        }
                    }

                    if (!typePasses) {
                        score--;
                    }
                }

                let inRange = false;

                for (const price of Object.values(vehicle.rate_per_day)) {
                    if (price >= context.selectedValues.priceRange.min && price <= context.selectedValues.priceRange.max) {
                        inRange = true;
                    }
                }

                if (!inRange) {
                    score--;
                }

                if (purposes.length > 0) {
                    let vehiclePurposes = vehicle.purposes;
                    if (!vehiclePurposes) {
                        score--;
                        vehiclePurposes = [];
                    }

                    let passedPurposes = 0;

                    for (let purpose of purposes) {
                        if (vehiclePurposes.indexOf(purpose.value) >= 0) {
                            passedPurposes++;
                        }
                    }

                    if (passedPurposes !== purposes.length) {
                        score--;
                    }
                }

                score = Math.max(0, score);
                filteredVehicles[score].push(vehicle);
            }
        }

        let matches = filteredVehicles[5],
            similarResults = []
        ;

        if (matches.length < 5) {
            for (let i = 4; i >= 0; i--) {
                for (let result of filteredVehicles[i]) {
                    similarResults.push(result);
                }
            }
        }

        let similar = similarResults.slice(0, 5);

        let result = {
            matches,
            similar
        };

        return result;
    }

    function _patchInputFieldsForMs($container, selector) {
        const $inputs = $container.querySelectorAll(selector);

        if ($inputs.length === 0) {
            return;
        }

        for (const $input of $inputs) {
            $input.setAttribute('step', 60);
        }
    }

    function _getAddressForLocationFromGroups(locationSlug, groups) {

    }

    let tomorrow = new Date().fp_incr(1);
    tomorrow.setHours(8);
    tomorrow.setMinutes(30);

    let dayAfter = new Date().fp_incr(2);
    dayAfter.setHours(8);
    dayAfter.setMinutes(30);

    export default {
        components: {
            AutoSuggestInput,
            flatPickr, Multiselect, ThrobberOverlay
        },
        props: {
            mapElementSelector: {
                type: String,
            },
            locations: {
                type: Array,
            },
            selectedLocations: {
                type: Array,
            },
            from: {
                type: String,
            },
            to: {
                type: String,
            },
            selectedVehicleTypes: {
                type: Array,
            },
            useColumns: {
                type: Boolean,
            },
            cdpCode: {
                type: String,
            },
            promoCoupon: {
                type: String,
            },
            rateCode: {
                type: String,
            },
            voucherNumber: {
                type: String,
            },
            hideVehicleTypeSelector: {
                type: Boolean,
                default: false,
            },
            hideLocationSelector: {
                type: Boolean,
                default: false,
            },
            hideToggles: {
                type: Boolean,
                default: false,
            },
            hidePriceRange: {
                type: Boolean,
                default: false,
            },
            noAutoSearching: {
                type: Boolean,
                default: false,
            },
            searchOnLoad: {
                type: Boolean,
                default: true,
            },
            purposes: {
                type: Array,
            },
            noCouponColumns: {
                type: Boolean,
                default: false,
            },
            noButton: {
                type: Boolean,
                default: false,
            },
            vehicleTypeList: {
                type: Array,
            },
            preventSubmit: {
                type: Boolean,
                default: true,
            },
            searchBySingleLocation: {
                type: Boolean,
                default: false,
            }
        },
        data: () => {
            return {
                mapElement: null,
                mapToggled: false,
                loadingStack$: 0,
                selectableLocations: [],
                selectableVehicleTypes: [],
                selectablePurposes: [],
                prefilledVehicleTypes: false,
                currentError: false,
                couponsVisible: false,
                returnToSameLocation: true,
                selectedValues: {
                    locations: [],
                    fromDate: '',
                    toDate: '',
                    fromTime: '',
                    toTime: '',
                    from: '',
                    to: '',
                    vehicles: [],
                    cdpCode: '',
                    promoCoupon: '',
                    rateCode: '',
                    voucherNumber: '',
                    priceRange: {
                        min: 0,
                        max: 500,
                    },
                    purposes: [],
                },
                serialisedPreviousSearch: '',
                throttle: null,
                dateConfig: {
                    fromDate: {
                        allowInput: true,
                        enableTime: false,
                        altFormat: "Y-m-d",
                        dateFormat: "M j, Y",
                        minDate: "today",
                        //defaultDate: tomorrow,
                    },
                    toDate: {
                        allowInput: true,
                        enableTime: false,
                        altFormat: "Y-m-d",
                        dateFormat: "M j, Y",
                        minDate: "today",
                        //defaultDate: dayAfter,
                    },
                    fromTime: {
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: "h:iK",
                        defaultHour,
                        defaultMinute,
                    },
                    toTime: {
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: "h:iK",
                        defaultHour,
                        defaultMinute,
                    },
                },
                lastCompleteSearchResponse: null,
                lastCompleteVehicleTypes: null,
                userChangedToDate: false,
                userChangedFromDate: false,
                dontFocusToTime: false,
            }
        },
        computed: {
            columnCount: function () {
                let columns = 3;

                if (this.hideVehicleTypeSelector) {
                    columns--;
                }

                if (this.hideLocationSelector) {
                    columns--;
                }

                return columns;
            },
            loadingSomething: function () {
                return this.loadingStack$ > 0;
            },
            columnSectionClassesDates: function() {
                return this.$_columnSectionClasses('dates');
            },
            columnSectionClassesVehicle: function() {
                return this.$_columnSectionClasses('vehicle');
            },
            columnSectionClassesLocation: function() {
                return this.$_columnSectionClasses('location');
            },
            canSubmit: function () {
                if (this.loadingSomething) {
                    return false;
                }

                let valid = true;

                if (this.selectedValues.locations.length === 0) {
                    valid = false;
                } else if (!this.selectedValues.fromDate || !this.selectedValues.toDate ||
                    !this.selectedValues.fromTime || !this.selectedValues.toTime) {
                    valid = false;
                }

                const serialisedCurrentValues = JSON.stringify(this.selectedValues);

                if (serialisedCurrentValues === this.serialisedPreviousSearch) {
                    valid = false;
                }

                // if (!this.hideVehicleTypeSelector && this.selectedValues.vehicles.length === 0) {
                //     console.info('!nvts, and no vehicles selected');
                //     valid = false;
                // }

                return valid;
            }
        },
        mounted() {
            this.mapElement = _getMapElement(this.mapElementSelector);

            if (this.purposes && this.purposes.length > 0) {
                this.selectablePurposes = this.purposes;
            }

            if (!this.locations) {
                _startLoadingSomething(this);
                Api.local.fetchStoredLocations()
                    .then(locations => {
                        this.selectableLocations = _transformLocationModelsStructure(locations);
                        _dispatchDomEvent(this.$el, events.selectableLocationsSet, {
                            method: 'fetched',
                            locations: this.selectableLocations
                        });
                        this.selectLocations(this.selectedLocations);
                    }, data => {
                        console.error('Failed to get locations', data);
                    })
                    .finally(() => _stopLoadingSomething(this))
                ;
            } else {
                this.selectableLocations = _transformLocationModelsStructure(this.locations);
                _dispatchDomEvent(this.$el, events.selectableLocationsSet, {
                    method: 'provided',
                    locations: this.selectableLocations
                });
                this.selectLocations(this.selectedLocations);
            }

            if (this.vehicleTypeList) {
                this.selectableVehicleTypes = this.vehicleTypeList;
            }

            if (this.from) {
                tomorrow = flatpickr.parseDate(this.from, `${this.dateConfig.fromDate.dateFormat} ${this.dateConfig.fromTime.dateFormat}`);
                this.selectedValues.fromDate = flatpickr.formatDate(tomorrow, this.dateConfig.fromDate.dateFormat);
                this.selectedValues.fromTime = flatpickr.formatDate(tomorrow, this.dateConfig.fromTime.dateFormat);
            }
            if (this.to) {
                dayAfter = flatpickr.parseDate(this.to, `${this.dateConfig.toDate.dateFormat} ${this.dateConfig.toTime.dateFormat}`);
                this.selectedValues.toDate = flatpickr.formatDate(dayAfter, this.dateConfig.toDate.dateFormat);
                this.selectedValues.toTime = flatpickr.formatDate(dayAfter, this.dateConfig.toTime.dateFormat);
            }

            _bind(this, '.filter-time', 'change', event => {
                this.$_maybeAttemptSearch();
            });

            //disable autocomplete...
            for (let $input of this.$el.querySelectorAll('input')) {
                $input.autocomplete = 'off';
            }

            let showCoupons = false;
            for (let v of ['cdpCode',
                'promoCoupon',
                'rateCode',
                'voucherNumber',]) {
                if (this[v]) {
                    showCoupons = true;
                    this.selectedValues[v] = this[v];
                }
            }
            this.couponsVisible = showCoupons;

            _patchInputFieldsForMs(this.$el, 'input[type="time"].flatpickr-input.flatpickr-mobile');

            _dispatchDomEvent(this.$el, events.initialized);
            this.$_dispatchVehicleChange();


            //enable a GPS button for the location search
            //@todo Refactor this out to a method, mounted() is getting heavy...
            if (navigator.geolocation && /^https/.test(document.location.href)) {
                if (this.$refs['location-search']) {
                    this.$refs['location-search'].enableActionButton('<i class="fas fa-location-arrow"></i>', 'Use my location', () => {
                        return new Promise((resolve, reject) => {
                            navigator.geolocation.getCurrentPosition(position => {
                                const lat = position.coords.latitude.toPrecision(8),
                                    lng = position.coords.longitude.toPrecision(8);
                                this.$refs['location-search'].setSearchQuery(`${lat},${lng}`);
                                resolve(position);
                            }, error => {
                                alert('There was an error determining your location');
                                reject(error);
                            }, {enableHighAccuracy: false});
                        });
                    });
                }
            }

            if (this.searchOnLoad) {
                window.setTimeout(() => {
                    this.$_maybeAttemptSearch(true);
                }, 200);
            }

        },
        methods: {
            dispatchToggleMap: function () {
                this.mapToggled = !this.mapToggled;
                _dispatchDomEvent(this.$el, events.mapToggled, {mapToggled: this.mapToggled});
            },
            /**
             * @todo The vehicle filter shouldn't require a list of locations to select from the map? Can be improved
             * @param slug
             */
            selectLocation: function (slug) {
                for (let group of this.selectableLocations) {
                    for (let location of group.locations) {
                        if (location.slug === slug) {
                            let result = true;
                            //this.selectedValues.locations = [location];
                            if (this.$refs['location-search']) {
                                this.$refs['location-search'].injectExternalResult(location.slug, location.name);
                                result = this.$refs['location-search'].toggleSelectionFromValue(location.slug);
                            }
                            this.$_dispatchLocationChange();
                            return result;
                        }
                    }
                }
                throw `Unknown location "${slug}" provided.`;
            },
            /**
             * @todo clean this one up, now we have the new selector...
             * @param locationSlugs
             * @returns {Promise<any>}
             */
            selectLocations: function (locationSlugs) {
                return new Promise((resolve, reject) => {
                    let selected = [];

                    if (!locationSlugs || locationSlugs.length === 0) {
                        resolve(selected);
                    }

                    for (let group of this.selectableLocations) {
                        for (let location of group.locations) {
                            for (let slug of locationSlugs) {
                                if (location.slug === slug) {
                                    if (this.$refs['location-search']) {
                                        this.$refs['location-search'].injectExternalResult(location.slug, location.name);
                                        this.$refs['location-search'].toggleSelectionFromValue(location.slug);
                                    }
                                    selected.push(location);
                                }
                            }
                        }
                    }

                    this.selectedValues.locations = selected;

                    resolve(selected);
                });
            },
            selectVehicles: function (vehicleSlugs) {
                if (this.selectableVehicleTypes.length === 0) {
                    throw 'There were no selectable vehicles?';
                }

                let selected = [];

                for (let type of this.selectableVehicleTypes) {
                    for (let slug of vehicleSlugs) {
                        if (type.slug === slug) {
                            selected.push(type);
                        }
                    }
                }

                this.selectedValues.vehicles = selected;
            },
            $_formatPrice(value) {
                let val = (value / 1).toFixed(2); //.replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            $_dispatchLocationChange: function () {
                //we need to do this because the multiselect widget (or <select> itself??) doesn't respect limits when group is clicked on
                if (this.selectedValues.locations.length > 3) {
                    this.selectedValues.locations = this.selectedValues.locations.slice(0, 3);
                }

                _dispatchDomEvent(this.$el, events.selectedLocation, {
                    selectedLocations: this.selectedValues.locations,
                });
                this.$_maybeAttemptSearch();
            },
            $_dispatchVehicleChange: function () {
                _dispatchDomEvent(this.$el, events.selectedVehicleTypes, {
                    selectedVehicles: this.selectedValues.vehicles,
                });

                let filteredVehicles = _filterVehicles(this);
                _dispatchDomEvent(this.$el, events.searchCompleted, filteredVehicles);
            },
            $_dispatchPriceChange: function () {
                _dispatchDomEvent(this.$el, events.updatedPriceRange, {
                    priceRange: this.selectedValues.priceRange,
                });

                let filteredVehicles = _filterVehicles(this);
                _dispatchDomEvent(this.$el, events.searchCompleted, filteredVehicles);
            },
            $_dispatchPurposeChange: function () {
                _dispatchDomEvent(this.$el, events.updatedVehiclePurpose, {
                    purposes: this.selectedValues.purposes,
                });

                let filteredVehicles = _filterVehicles(this);
                _dispatchDomEvent(this.$el, events.searchCompleted, filteredVehicles);
            },
            $_dispatchCouponChange: function () {
                let coupons = {
                    cdpCode: this.cdpCode,
                    promoCoupon: this.promoCoupon,
                    rateCode: this.rateCode,
                    voucherNumber: this.voucherNumber,
                };

                _dispatchDomEvent(this.$el, events.updatedVehicleCoupons, {
                    coupons,
                });
                this.$_maybeAttemptSearch();
            },
            $_maybeAttemptSearch: function (force = false) {
                //don't bother searching if we don't have the type selector...
                if (!force && (this.noAutoSearching || !this.canSubmit)) {
                    return;
                }

                let serialisedCurrentValues;

                serialisedCurrentValues = JSON.stringify(this.selectedValues);

                if (!force && serialisedCurrentValues === this.serialisedPreviousSearch) {
                    return;
                }

                for (let x of ['from', 'to']) {
                    let val = this.selectedValues[x];
                    //VERY rudimentary date format check...
                    if (!val || !/^[^,]+,[^:]+:.*$/.test(val)) {
                        return;
                    }
                }

                //are from or to empty?
                if (!this.selectedValues.from || !this.selectedValues.to) {
                    return;
                }

                if (this.throttle !== null) {
                    window.clearTimeout(this.throttle);
                    this.throttle = null;
                    _stopLoadingSomething(this)
                }

                _startLoadingSomething(this);

                _dispatchDomEvent(this.$el, events.startSearch, {
                    message: 'Searching...',
                });

                this.serialisedPreviousSearch = serialisedCurrentValues;
                document.activeElement.blur();

                this.throttle = window.setTimeout(async () => {
                    let locations = [], vehicleTypes = [];

                    for (let location of this.selectedValues.locations) {
                        locations.push(typeof location === 'string' ? location : location.slug);
                    }

                    for (let vehicleType of this.selectedValues.vehicles) {
                        vehicleTypes.push(typeof vehicle === 'string' ? vehicle : vehicleType.slug);
                    }

                    this.currentError = false;

                    //@todo deprecate this one?
                    this.lastCompleteVehicleTypes = [];
                    for (const vehicleType of this.selectableVehicleTypes) {
                        this.lastCompleteVehicleTypes.push(vehicleType.slug);
                    }

                    this.lastCompleteSearchResponse = [];
                    const knownIds = new Map();
                    let filteredVehicles;
                    let lastError = null;

                    for (const vehicleType of this.selectableVehicleTypes) {
                        try {

                            _dispatchDomEvent(this.$el, events.startSearch, {
                                message: `Searching ${vehicleType.name.toLowerCase()}...`,
                                partial: true,
                            });

                            const slugResults = await _attemptSearch(locations, [vehicleType.slug],
                                this.selectedValues.from,
                                this.selectedValues.to,
                                this.selectedValues.cdpCode,
                                this.selectedValues.promoCoupon,
                                this.selectedValues.rateCode,
                                this.selectedValues.voucherNumber
                            );

                            for (const result of slugResults) {
                                if (knownIds.has(result.id)) {
                                    continue;
                                }
                                knownIds.set(result.id, true);
                                this.lastCompleteSearchResponse.push(result);
                            }

                            //@todo Should vehicle filtering be of the chunks returned, or complete and growing list (as this currently does)
                            filteredVehicles = _filterVehicles(this);
                            _dispatchDomEvent(this.$el, events.searchCompleted, filteredVehicles);
                        }
                        catch (reason) {
                            // console.warn(`There was an error searching for slug: ${vehicleType.slug}: `, reason);
                            lastError = reason;
                        }
                    }

                    if (this.lastCompleteSearchResponse.length === 0 && lastError) {
                        _dispatchDomEvent(this.$el, events.searchCompleted, lastError);
                    }

                    this.throttle = null;
                    _stopLoadingSomething(this);
                }, 200);
            },
            $_showLocationWarning: function (event) {
                const modal = VueUtils.getRef('modal-dialog');
                const locations = this.selectedValues.locations;

                let content;

                if (locations.length === 0) {
                    content = 'Please contact the locations to arrange a booking with different pickup and dropoff locations.';
                } else {
                    content = '<p>Please contact the locations to arrange a booking with different pickup and dropoff locations</p>';

                    const last = locations[locations.length - 1];
                    for (let location of locations) {
                        location = this.$_getLocationObject(location);

                        content += `<strong>${location.name}</strong><br>` +
                            `<em class="pl-3 d-block pt-3 pb-3">${location.address_lines.join('<br>')}</em>`
                        ;

                        let contactMethods = [];
                        for (let field of ['email_address', 'phone_landline', 'phone_mobile']) {
                            if (location[field]) {
                                contactMethods.push(
                                    `<a href="${field.indexOf('phone')>-1?'tel':'mailto'}:${location[field]}">` +
                                    location[field] +
                                    '</a>'
                                );
                            }
                        }

                        if (contactMethods.length > 0) {
                            content += `<ul class="ml-3"><li>${contactMethods.join('</li><li>')}</li></ul>`;
                        }

                        if (location !== last) {
                            content += '<br>';
                        }

                        content = `<div>${content}</div>`;
                    }
                }

                modal.setContent(content);
                //if the value never changes, Vue doesn't repaint the component...
                window.setTimeout(() => {
                    this.returnToSameLocation = false;
                    window.setTimeout(() => {
                        this.returnToSameLocation = true;
                    }, 50);
                }, 50);
            },

            $_getLocationObject: function(query) {
                if (typeof query === 'object') {
                    return query;
                }

                if (typeof query === 'string') {
                    for (const group of this.locations) {
                        for (const location of group.locations) {
                            if (location.slug === query) {
                                return location;
                            }
                        }
                    }
                }

                //???
                return query;
            },
            $_showCouponHelp: function () {
                const modal = VueUtils.getRef('modal-dialog');
                const $content = this.$el.querySelector('.coupon-help-text');

                modal.setContent($content, true);
            },
            $_fromDateChange: function (dates) {
                this.userChangedFromDate = true;
                this.dontFocusToTime = true;
                if (!this.userChangedToDate && !this.to) {
                    let newDate = dates[0].fp_incr(1);
                    newDate.setHours(dates[0].getHours());
                    newDate.setMinutes(dates[0].getMinutes());
                    this.selectedValues.toDate = newDate;
                    window.setTimeout(() => {
                        //we need to reset this, as the change events wipes it
                        this.userChangedToDate = false;
                    }, 10);
                }
                //this.$_fromChange();
            },
            $_toDateChange: function () {
                this.userChangedToDate = true;
                //this.$_toChange();
            },
            $_fromTimeChange: function (dates) {
                //this.$_fromChange();
            },
            $_toTimeChange: function () {
                //this.$_toChange();
            },
            $_updateTimeValues: function(kind) {
                //lazily account for event ordering....
                window.setTimeout(() => {
                    const names = ['fromDate', 'fromTime', 'toDate', 'toTime'];

                    for (let name of names) {
                        //there is a race issue (due to timeouts), so this check actually causes issues for keyboard users when they change am/pm
                        // if (this.selectedValues[name] !== '') {
                        //   console.warn('bailing coz already value', name);
                        //     continue;
                        // }

                        let $input = this.$el.querySelector(`input[name="${name}"]`);
                        if (!$input) {
                            continue;
                        }

                        if ($input.value.trim() === '') {
                            continue;
                        }

                        this.selectedValues[name] = $input.value;
                    }

                    let prevFrom = this.selectedValues.from;
                    let prevTo = this.selectedValues.to;

                    this.selectedValues.from = `${this.selectedValues.fromDate} ${this.selectedValues.fromTime}`;
                    this.selectedValues.to = `${this.selectedValues.toDate} ${this.selectedValues.toTime}`;

                    let canTrySearch = true;
                    let valuesChanged = prevFrom != this.selectedValues.from || prevTo != this.selectedValues.to;

                    switch (kind) {
                        case 'open':
                            canTrySearch = false;
                            break;
                    }

                    // canTrySearch = canTrySearch && valuesChanged;

                    if (canTrySearch) {
                        this.$_maybeAttemptSearch();
                    }
                }, 50);
            },
            $_columnSectionClasses: function (which) {
                const originalWidth = (function () {
                    switch (which) {
                        case 'location':
                            return 5;
                        case 'dates':
                            return 3;
                        case 'vehicle':
                            return 4;
                        default:
                            return 3;
                    }
                })();

                let classes = [];

                classes.push(`c-${which}`);

                if (!this.useColumns) {
                    classes.push('w-100');
                } else {

                    let columns = this.columnCount, newClass = 'col-md-' + originalWidth;

                    switch (columns) {
                        case 2:
                            newClass = which === 'location' ? 'col-md-7' : 'col-md-5';
                            break;
                        case 1:
                            newClass = 'col-md-12';
                            break;
                    }

                    classes.push(newClass);
                }

                return classes;
            },

            $_searchFromClick: function(event) {
                //search via ajax
                if (this.preventSubmit) {
                    this.$_maybeAttemptSearch(true);
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    return false;
                }
            },

            getSelectedTypes: function() {
                let hasType = false;
                let types = {};
                const entries = Object.entries(this.selectedValues.vehicles);

                for (const type of entries) {
                    hasType = true;
                    types[type[1].slug] = type[1];
                }

                return hasType ? types : null;
            },

            getSelectedPurposes: function() {
                return this.selectedValues.purposes;
            },
        }
    }
</script>
